( function( $ ) {
	$( document ).ready( () => {
		var $galleries = $( '.section__photo-gallery' );

		$.each( $galleries, function( index, gallery ) {
			var $gallery = $( gallery );
			var $images = $gallery.find( '.photo-gallery__images' );
			var $controls = $gallery.find( '.photo-gallery__controls' );
			$images.slick( {
				appendArrows: $controls,
				prevArrow: '<button class="photo-gallery__control reset"><i class="photo-gallery__control-icon icon icon-arrow-left"></i><span class="screen-reader-text">Scroll to previous image.</span></button>',
				nextArrow: '<button class="photo-gallery__control reset"><i class="photo-gallery__control-icon icon icon-arrow-right"></i><span class="screen-reader-text">Scroll to previous image.</span></button>'
			} );
		} );
	} )
} ( jQuery ) )



// WEBPACK FOOTER //
// ./assets/js/components/layout/gallery.js